import React, { useState } from 'react'
import DataTable from '../datatable'
import { PAGINATION_DEFAULT } from '../../utils/constants'
import {
  useExportAdminActivityLogs,
  useExportUserActivityLogs,
  useGetActivityLogs,
  useGetUserActivityLogs,
} from '../../redux/company/hook'
import { useSelector } from 'react-redux'
import { setAlert } from '../../redux/components/components-slice'
import { store } from '../../redux'
import Excel from 'exceljs'
import Button from '../button'

const ActivityLogs = () => {
  const { user } = useSelector((state) => state.userSlice)
  const checkUser = user?.permissions?.company_permission?.role === 'Owner'
  const workbook = new Excel.Workbook()
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })

  const { data: activityLogs } = useGetActivityLogs(
    pagination?.limit,
    pagination?.page
    // pagination?.search
  )

  const { data: userActivityLogs } = useGetUserActivityLogs(
    pagination?.limit,
    pagination?.page
    // pagination?.search
  )

  const [exportLoading, setSetExportLoading] = useState(false)

  const { mutateAsync: exportUserActivityLogs } = useExportUserActivityLogs()
  const { mutateAsync: exportAdminActivityLogs } = useExportAdminActivityLogs()

  const columns = [
    { header: 'First Name', key: 'firstname' },
    { header: 'Last Name', key: 'lastname' },
    { header: 'Date Created', key: 'created' },
    { header: 'Event', key: 'event' },
    { header: 'Description', key: 'description' },
  ]

  const exportActivityLogsData = async () => {
    setSetExportLoading(true)
    let payload = {
      limit: 100000,
      page: 1,
    }

    const exportFunction = checkUser
      ? exportAdminActivityLogs
      : exportUserActivityLogs

    await exportFunction(payload).then(async (response) => {
      if (response) {
        let data = response.data.data
        const workSheetName = checkUser
          ? 'Owner Activity logs'
          : 'Admin Activity logs'
        const workBookName = checkUser
          ? 'Owner Activity logs'
          : 'Admin Activity logs'
        try {
          const fileName = workBookName
          const worksheet = workbook.addWorksheet(workSheetName)

          // add worksheet columns
          // each columns contains header and its mapping key from data
          worksheet.columns = columns

          worksheet.columns.forEach((column) => {
            if (column._number === 3 || column._number === 4) {
              column.width = 30
              column.style.alignment = { horizontal: 'left' }
            } else if (column._number === 5) {
              column.width = 40
              column.style.alignment = { horizontal: 'left' }
            } else {
              column.width = column.header.length + 10
              column.style.alignment = { horizontal: 'left' }
            }
          })

          // updated the font for first row.
          worksheet.getRow(1).font = { bold: true }

          // loop through data and add each one to worksheet
          data.forEach((singleData) => {
            worksheet.addRow(singleData)
          })

          // loop through all of the rows and set the outline style.
          worksheet.eachRow({ includeEmpty: false }, (row) => {
            // store each cell to currentCell
            const currentCell = row._cells

            // loop through currentCell to apply border only for the non-empty cell of excel
            currentCell.forEach((singleCell) => {
              // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
              const cellAddress = singleCell._address

              // apply border
              worksheet.getCell(cellAddress).border = {
                top: { style: 'none' },
                left: { style: 'none' },
                bottom: { style: 'none' },
                right: { style: 'none' },
              }
            })
          })

          // write the content using writeBuffer
          const buf = await workbook.xlsx.writeBuffer()

          // download the processed file
          saveAs(new Blob([buf]), `${fileName}.xlsx`)
        } catch (error) {
          // console.error('<<<ERRROR>>>', error);
          // console.error('Something Went Wrong', error.message);
        } finally {
          workbook.removeWorksheet(workSheetName)
        }
      } else {
        store.dispatch(setAlert(true, 'info', 'No Activity logs to export'))
      }
    })
    // store.dispatch(
    //   setAlert(true, 'info', 'Activity logs exported successfully')
    // )
    setSetExportLoading(false)
  }

  const logsData = checkUser ? activityLogs : userActivityLogs

  const tableConfig = {
    headers: ['Name', 'Date Created', 'Event', 'Description'],
    keys: ['name', 'created', 'event', 'description'],
    mobileHeader: {
      left: {
        title: 'Date Created',
        key: 'created',
      },
      right: {
        title: 'Event',
        key: 'event',
      },
    },
  }
  const actionConfig = []

  return (
    <div className='flex flex-col gap-2.5'>
      <div className='flex md:flex-row flex-col items-center gap-2.5 w-full justify-between'>
        <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
          Activity Logs
        </div>
        <div className='w-[120px] flex md:justify-end justify-center'>
          <Button
            text={`Export`}
            type='button'
            loading={exportLoading}
            className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
            textClass={'!text-[11px]'}
            leftIcon={'export'}
            onClick={() => exportActivityLogsData()}
          />
        </div>
      </div>

      <DataTable
        data={logsData}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={'table'}
        noCheck={true}
      />
    </div>
  )
}

export default ActivityLogs
